import { render, staticRenderFns } from "./options-input.vue?vue&type=template&id=4b60f6a8"
import script from "./options-input.vue?vue&type=script&lang=js"
export * from "./options-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports